// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"423":"7c491e2e","437":"61277312","819":"24a1578b"}[chunkId] + ".css";
};